export const animationSettings = {
  fs_start_popup: {
    'default': ['static', false],
    'ACTION:FS-START': ['play', false, 'start-fs-in', { name: 'IN-START-DONE', delay: 1.5 }],
    'IN-START-DONE': ['play', true, 'start-fs'],
    'BUTTON:start': ['play', false, 'start-fs-out', { name: 'BUTTON:startFreespin', delay: 1 }],
  },

  fs_end_popup: {
    'default': ['static', false],
    'ACTION:FS-END': ['play', false, 'end-fs-in', { name: 'IN-END-DONE', delay: 1.5 }],
    'IN-END-DONE': ['play', true, 'end-fs'],
    'BUTTON:end': ['play', false, 'end-fs-out', { name: 'BUTTON:endFreespin', delay: 1 }],
  },

  scatter_text_2: {
    'default': ['static', false],
    'SCATTER:START-2': ['play', true, 'text'],
  },

  scatter_text_3: {
    'default': ['static', false],
    'SCATTER:START-3': ['play', true, 'text'],
  },

  scatter_text_4: {
    'default': ['static', false],
    'SCATTER:START-4': ['play', true, 'text'],
  },
}
